import { Component, OnInit } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-sk-health-authority-logo',
  templateUrl: './sk-health-authority-logo.component.html',
  styleUrls: ['./sk-health-authority-logo.component.less']
})
export class DynacareLogoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
